import { TableSelect } from "../types/select";
import { ItemSelectBehavior } from "../types/table";

interface Props {
    item: Record<string, any>;
    idx: number;
    indexer: string;
    selectedItems: TableSelect[];
    sortedData: Record<string, any>[];
    itemSelectBehavior: ItemSelectBehavior;
}

const getUpdatedTableSelectedItems = ({
    item,
    idx,
    indexer,
    selectedItems,
    sortedData,
    itemSelectBehavior,
}: Props): TableSelect[] => {
    switch (itemSelectBehavior) {
        // for selecting one item w/ checkbox behavior (with metakey)
        case ItemSelectBehavior.Checkbox:
            if (
                selectedItems
                    .map((selectedItem) => selectedItem.value)
                    .includes(item[indexer])
            ) {
                // if found in selected already, remove it
                return selectedItems.filter(
                    (selectedItem) => selectedItem.value !== item[indexer]
                );
            }
            return [
                ...selectedItems,
                {
                    value: item[indexer],
                    idx,
                },
            ];
        // for selecting one item w/ radio button behavior (default)
        case ItemSelectBehavior.Radio:
            if (
                selectedItems
                    .map((selectedItem) => selectedItem.value)
                    .includes(item[indexer])
            ) {
                return [];
            }
            return [
                {
                    value: item[indexer],
                    idx,
                },
            ];
        // for selecting multiple items at once (shift-key)
        case ItemSelectBehavior.Range:
            let startIdx: number, endIdx: number;

            if (selectedItems.length === 0) {
                return [
                    {
                        value: item[indexer],
                        idx,
                    },
                ];
            }

            const selection = [...selectedItems.map((item) => item.idx)];
            let minSelection = Math.min(...selection);
            let maxSelection = Math.max(...selection);

            startIdx = idx <= minSelection ? idx : maxSelection;
            endIdx = idx >= maxSelection ? idx : minSelection;

            return sortedData
                .map((row, idx) => ({
                    ...row,
                    idx,
                }))
                .filter((_row, idx) => idx >= startIdx && idx <= endIdx)
                .map((row: Record<string, any>) => ({
                    idx: row.idx,
                    value: row[indexer],
                }));
    }
};

export default getUpdatedTableSelectedItems;
